import { useWindowDimensions } from 'react-native';
import UseScreenDimesions from 'types/hooks/UseScreenDimesions';

export default (): UseScreenDimesions => {
  const { width } = useWindowDimensions();
  const isSmallScreen = width < 768;
  return { isSmallScreen };
};
